import React from 'react';

import Select from '../../../../components/Blackbird/Forms/Select/Select';
import TimeAndTimezone from './TimeAndTimezone';
import { daysOfWeek } from './utils/constants';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

interface Props {
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
}

export default function WeeklyForm({ register, errors }: Props) {
  return (
    <div data-testid="weekly-form" className="ma-12-top">
      <Select
        showErrorMessageBelow
        errors={errors}
        label="Run every"
        inputName="ingestionSchedule.0.schedule"
        selectProps={{
          ...register('ingestionSchedule.0.schedule', {
            required: 'Select the day of week',
            shouldUnregister: true,
            setValueAs: (value) => value,
          }),
          style: {
            textTransform: 'capitalize',
          },
        }}
      >
        {daysOfWeek.map((day) => (
          <option key={day}>{day}</option>
        ))}
      </Select>

      <TimeAndTimezone register={register} errors={errors} />
    </div>
  );
}
